<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="header">Processando Solicitação</h2>
        <v-alert :value="running" type="warning" icon="warning">
          Permaneça na tela enquanto realizamos a análise de regras para aprovação automática...
        </v-alert>
        <h4 v-if="!running" class="sub_header">
          Processo executado.
        </h4>
      </v-flex>
    </v-layout>
    <slot name="steps" />
    <div v-if="!running">
      <div :class="resultBoxClasses">
        <v-icon class="white--text">{{ detailIcon }}</v-icon>
        <p class="ma-0 ml-3 font-weight-bold" style="flex-grow: 1">
          {{ detailedMessage }}
        </p>
      </div>
    </div>
    <div class="mt-3" style="text-align: right">
      <v-btn :disabled="running" class="button jns-button yellow-button" style="width: auto !important" @click="goto">
        <fragment v-if="hasCompleted"> Seguir para emissão <v-icon>arrow_right_alt</v-icon> </fragment>
        <fragment v-if="hasFailed"> Visualizar timeline da proposta <v-icon>arrow_right_alt</v-icon> </fragment>
        <fragment v-if="running">
          Executando...
        </fragment>
      </v-btn>
    </div>
  </div>
</template>

<script lang="js">
import { PROGRESS, ERRO } from "@/components/Apolice/Steps/AutomaticApproval.js";

export default {
  name: "ProcessoSolicitacaoProposta",
  props: {
    "process": { type: Object },
  },
  computed: {
    resultBoxClasses() {
      return {
        "white--text": true,
        "box": true,
        "error-box": this.hasError,
        "success-box": !this.hasError,
        "pa-3": true,
        "mt-3": true
      };
    },
    running() {
      return this.process.status === PROGRESS;
    },
    hasError() {
      return this.process.status === ERRO;
    },
    hasCompleted() {
      return !this.running && !this.hasError;
    },
    hasFailed() {
      return !this.running && this.hasError;
    },
    detailIcon() {
      return this.hasError ? "cancel" : "check_circle";
    },
    detailedMessage() {
      if (!this.hasError) {
        return "Proposta aprovada automaticamente.";
      }
      return this.process.error || "Aprovação automática falhou.";
    }
  },
  methods: {
    goto() {
      return this.$emit(
        "goto",
        this.hasCompleted ? "next-step" : "timeline"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
$colorSuccess: #6bd43e;
$colorError: #e2005d;

.box {
  display: flex;
  justify-items: start;
  border-radius: 5px;
}
.error-box {
  background-color: #d21a5e;
}
.success-box {
  background-color: #7ed321;
}
</style>



// WEBPACK FOOTER //
// ./src/components/Apolice/Steps/ProcessoSolicitacaoProposta.vue